<template>
  <div v-if="showUpdateNotification" class="update-notification">
    <div class="update-notification-content">
      <i class="fa-solid fa-download update-icon"></i>
      <span class="update-text">بروزرسانی جدید در دسترس است</span>
      <button @click="performDirectUpdate" class="update-now-btn">
        بروزرسانی
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateNotification',
  props: {
    showUpdateNotification: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    performDirectUpdate() {
      this.$emit('performUpdate');
    }
  }
}
</script>

<style scoped>
.update-notification {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #6153cc 0%, #fd7691 100%);
  color: white;
  z-index: 10000;
  padding: 10px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  animation: slideDown 0.5s ease-out;
}

.update-notification-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  max-width: 1200px;
  margin: 0 auto;
}

.update-icon {
  font-size: 18px;
  animation: pulse 2s infinite;
}

.update-text {
  font-size: 16px;
  font-weight: bold;
  font-family: IRANSansWeb;
}

.update-now-btn {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-family: IRANSansWeb;
  transition: all 0.3s ease;
}

.update-now-btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

@media (max-width: 768px) {
  .update-notification-content {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .update-text {
    font-size: 14px;
  }
  
  .update-now-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
}
</style>
